module.exports = __webpack_public_path__ + "img/01_leader.99783f62.jpg";